import { useId } from 'react';

/**
 * SaveAnimatedIcon — Ícone de salvar (disquete) animado padrão do Joshua.
 *
 * Uso: envolva com um elemento que tenha a classe `save-animated`
 * para ativar a animação no hover (frame empurra, slot desliza, panel pop).
 *
 * Exemplo:
 *   <button className="btn-add save-animated" onClick={onSave}>
 *     <SaveAnimatedIcon size={16} />
 *     <span className="btn-text">{saving ? 'Salvando...' : 'Salvar'}</span>
 *   </button>
 */
export default function SaveAnimatedIcon({ size = 16 }) {
  const id = useId();
  const gid = `saveG${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="3" y1="0" x2="21" y2="0">
          <stop offset="0%" stopColor="#60a5fa" />
          <stop offset="100%" stopColor="#154680" />
        </linearGradient>
      </defs>
      <g className="save-frame" stroke={`url(#${gid})`}>
        <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
      </g>
      <g className="save-panel" stroke={`url(#${gid})`}>
        <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/>
      </g>
      <g className="save-slot" stroke={`url(#${gid})`}>
        <path d="M7 3v4a1 1 0 0 0 1 1h7"/>
      </g>
    </svg>
  );
}
